<template>
  <div class="box">
    <div class="add" @click="toInvoiceAdd">
      <img src="../../../../assets/images/icon-address-add@2x.png" alt="" />
      <h1>添加发票信息</h1>
    </div>
    <div>
      <div class="address_list">
        <div v-for="(item, index) in invoiceList" :key="index">
          <div class="address_info" @click="InvoiceEdit(item.id)">
            <div class="header">
              <h1>{{ item.taitou }}</h1>
              <!-- <div v-if="item.is_default == 1" class="first">默认</div> -->
            </div>
            <div class="body">{{ item.shuihao }}</div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddressAdd",
  data() {
    return {
      invoiceList: [],
    };
  },
  components: {},
  mounted() {
    document.title = "发票薄";
    this.getInvoice();
  },
  methods: {
    getInvoice() {
      let that = this;
      this.$api.get("/api/user/invoiceList", {}, (res) => {
        console.log(res);
        // let showAdd = res.data.length>0 ? false:true;
        that.invoiceList = res.data;
        // that.showAdd = showAdd;
      });
    },
    InvoiceEdit(id) {
      rbLink({
        name: "InvoiceEdit",
        query: {
          id: id,
        },
      });
      // this.$router.push({
      //   path: "invoiceedit",
      //   query: {
      //     id: id,
      //   },
      // });
    },
    toInvoiceAdd() {
      // this.$router.push("invoiceadd");
      rbLink({
        name: "InvoiceAdd",
      });
    },
  },
};
</script>
<style scoped>
.box {
  height: 843px;
  background: #f8f8f8;
}
.add {
  display: flex;
  justify-content: flex-end;
}
.add img {
  width: 0.4rem;
  height: 0.4rem;
  margin-top: 0.24rem;
  margin-right: 0.2rem;
}
.add h1 {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fa6400;
  line-height: 23px;
  margin-right: 0.2rem;
  margin-top: 0.2rem;
}
.address_list {
  margin-top: 11px;
  margin-left: 10px;
  margin-right: 10px;
  background: #ffffff;
  border-radius: 4px;
}
.address_info {
  padding: 15px 15px 0px 15px;
}
.header {
  display: flex;
}
.header h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
}
.header text {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  margin-left: 7px;
}
.body {
  margin-top: 5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.line {
  width: 95%;
  height: 1px;
  background: #ebedf0;
  margin: 0 auto;
  margin-top: 15px;
}
.first {
  margin-left: 12px;
  margin-top: 3px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid #fa6400;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fa6400;
  line-height: 14px;
}
</style>



// WEBPACK FOOTER //
// InvoiceList.vue?9ed3af70